export class FabHold {
    id!: string
    indexId!: number
    fabPieceId!: string
    fabHoldReasonId!: string
    fabProcessStepId?: string | null
    ownerUserId?: string | null
    startedOn!: Date | string
    expectedReleaseDate?: Date | string | null
    releasedOn?: Date | string | null
    description?: string | null
    releaseNote?: string | null
    modifiedDate?: Date | string
    modifiedByUserId?: string
    reasonName?: string
    pieceName?: string
    markCode?: string
    scope?: string
    jobDisplayName?: string
    processStepName?: string
    daysHeld!: number
    isOpen!: boolean
}

export class FabHoldReleaseRequest {
    fabHoldId!: string
    releasedOn?: Date | string | null
    releaseNote?: string | null
}
